angular.module('impactx.disposition').controller('DispositionUserOwnTemplateListCtrl', [
    '$scope',
    'dataGen',
    '$context',
    '$redirect',
    'selectedListItems',
    DispositionUserOwnTemplateListCtrl]);

function DispositionUserOwnTemplateListCtrl($scope, dataGen, $context, $redirect, selectedListItems)
{
    var ctrl = this;
    this.createDispositionTemplate = function()
    {
        dataGen.post($scope, {}, "/disposition/createtemplate", function ()
        {
            $context.refreshBasket({}, dataGen, $context);
            $redirect.redirectTo(  null,"/basket");
        });
    };

    this.getDetailLink = function() {
        return "basket/" + selectedListItems.getFirstSelectedId();
    };

    this.getDispositionWaitLink = function() {
        return "dispositionwait";
    };
    var buttonDefinition = [
        {label: "dispositionwait", linkFunction: ctrl.getDispositionWaitLink, type:'link', condition:  selectedListItems.isNoSelection, process: 'ViewDispositionWait'},
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'CreateDispositionTemplate'}
    ];

    this.meta = {
        rowTemplate: 'modules/disposition/templates/dispositionuserowntemplatelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/disposition/user/own/list',
        id: 'dispositionuserowntemplatelist',
        excelExport: true,
        mainActionFunction: {id:"new", action: ctrl.createDispositionTemplate, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}